"use client";

import { ICONS_VARIABLE_NAMES } from "@/common/globalTypes/enums/common";

const Unlike = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d={`M6.81203 13.9992L6.81203 14.126C6.6268 14.0208 6.45486 13.8832 6.32401 13.7057C6.14388 13.4614 5.9904 13.0733 6.07475 12.42L6.53353 
        10.6254C6.72976 9.85916 6.17468 9.05083 5.32963 9.05083L2.48815 9.05083C2.0443 9.05083 1.65814 8.61233 1.7687 8.09323L2.9791 2.41122C3.06375 
        2.01151 3.39973 1.74997 3.75791 1.74997L7.89496 1.74997C8.18897 1.74997 8.48207 1.80276 8.76266 1.9072C9.14681 2.05091 9.7255 2.26568 10.4794 
        2.54384L10.4794 8.26464L7.59899 11.782C7.35035 12.0845 7.1579 12.4257 7.02556 12.7885C6.88478 13.1744 6.81203 13.5848 6.81203 13.9992ZM8.31203
         14.4459C8.31203 15.322 7.44244 16.0019 6.56709 15.6642C6.11975 15.4917 5.54303 15.1743 5.11659 14.5957C4.67506 13.9968 4.45035 13.1935
          4.59475 12.1713L4.60052 12.1305L5.00436 10.5508L2.48815 10.5508C1.03254 10.5508 0.00441895 9.17598 0.301615 7.7807L1.51193 2.09911C1.73715 
          1.03668 2.66068 0.249974 3.75791 0.249974L7.89496 0.249975C8.36972 0.249975 8.84123 0.335714 9.28815 0.502256C9.59177 0.615844 10.0191 
          0.774627 10.5607 0.974838C10.7199 0.562012 11.1143 0.255296 11.6011 0.255296L14.6335 0.255297C15.271 0.255297 15.75 0.781343 
          15.75 1.38286L15.75 10.0189C15.75 10.6204 15.271 11.1464 14.6335 11.1464L11.6011 11.1464C11.1421 11.1464 10.7654 10.8738 10.5903 
          10.4967L8.75911 12.7328L8.75819 12.7339C8.47162 13.0825 8.31203 13.5325 8.31203 13.9992L8.31203 14.4459ZM14.25 1.7553L14.25 9.64642L11.9846 
          9.64642L11.9846 1.7553L14.25 1.7553Z`}
        fill={ICONS_VARIABLE_NAMES.primary}
      />
    </svg>
  );
};

export default Unlike;
